'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$45() {
  this.biQ = null;
  this.biR = false;
}
export { $c_Lpresto_PrestoRouter$$anon$45 as $c_Lpresto_PrestoRouter$$anon$45 };
$p = $c_Lpresto_PrestoRouter$$anon$45.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$45;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$45() {
}
export { $h_Lpresto_PrestoRouter$$anon$45 as $h_Lpresto_PrestoRouter$$anon$45 };
$h_Lpresto_PrestoRouter$$anon$45.prototype = $p;
$p.bW = (function() {
  if ((!this.biR)) {
    this.biQ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_T$package$EmptyTuple$();
    this.biR = true;
  }
  return this.biQ;
});
$p.P = (function() {
  return this.bW();
});
var $d_Lpresto_PrestoRouter$$anon$45 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$45, "presto.PrestoRouter$$anon$45", ({
  Oc: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$45 as $d_Lpresto_PrestoRouter$$anon$45 };
//# sourceMappingURL=presto.-Presto-Router$$anon$45.js.map
